<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps<{
  name: string;
  subtitle?: string;
}>();

defineEmits<{ (e: 'remove'): void }>();

const initials = computed(() => {
  const parts = props.name?.split(/\s/).filter(Boolean) ?? [];
  if (parts.length === 0) return 'UK';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return `${parts[0].at(0)}${parts[1].at(0)}`.toUpperCase();
});
</script>

<template>
  <div class="flex items-center gap-3 py-2">
    <div
      data-test="candidate-initials"
      class="flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-md bg-highlight-50 text-xs font-bold text-highlight-700"
    >
      {{ initials }}
    </div>
    <div class="min-w-0 flex-1">
      <p class="truncate text-sm font-bold text-shade-900">{{ name }}</p>
      <p v-if="subtitle" class="truncate text-xs text-shade-800">{{ subtitle }}</p>
    </div>
    <button
      data-test="remove-candidate"
      type="button"
      class="flex-shrink-0 p-1 text-shade-700 hover:text-shade-900"
      @click="$emit('remove')"
    >
      <svg
        width="18"
        height="18"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3 6h18M8 6V4a1 1 0 011-1h6a1 1 0 011 1v2m2 0v14a1 1 0 01-1 1H7a1 1 0 01-1-1V6h12z"
          stroke="currentColor"
          stroke-width="1.6"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  </div>
</template>
